import { ENV_VALUES } from '@/config/env';
import Vue from 'vue';
import App from './App.vue';
// import VueFullscreen from 'vue-fullscreen';
import VueYouTubeEmbed from 'vue-youtube-embed';
import router from './router/index';
// @ts-expect-error there is no ts declaration file
import Ripple from 'vue-ripple-directive';
import i18n from './i18n';
import vuetify from './plugins/vuetify';
// @ts-expect-error there is no ts declaration file
import VueSignaturePad from 'vue-signature-pad';
// @ts-expect-error there is no ts declaration file
import VueEditor from 'vue2-editor';
import { initSentry } from './plugins/sentry';

// Initialize Sentry with router after router is created to avoid dependency cycle
initSentry(router);

console.log(`Started in ${ENV_VALUES.NODE_ENV} mode`);

Vue.use(VueSignaturePad);
Vue.use(VueEditor);
// Ripple.color = 'rgba(53, 64, 136, 0.5)';  // blue
Ripple.color = 'rgba(103, 173, 112, 0.5)'; // green
// Ripple.color = 'rgba(255, 255, 255, 0.35)'; // white
// Ripple.zIndex = 55;
// Vue.directive('ripple', Ripple);

Vue.config.productionTip = false;

// Vue.use(VueFullscreen);
Vue.use(VueYouTubeEmbed);

new Vue({
  router,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
